/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { MicrotaskAssignmentRecord } from '@karya/core';
import { ComponentPath } from '@karya/generic-task-react';
import { RenderExecutionHistory } from './RenderExecutionHistory';

export interface RenderCompletedAssignmentProps {
  assignment: MicrotaskAssignmentRecord;
}

/**
 * Renders a completed assignment by directly rendering its saved history
 * without using the controller. This is more efficient than re-executing
 * the task specification.
 */
export function RenderCompletedAssignment(props: RenderCompletedAssignmentProps) {
  const report = props.assignment.report as { history_web?: ComponentPath } | null | undefined;
  const history = report?.history_web;

  if (!history || history.length === 0) {
    return null;
  }

  return <RenderExecutionHistory history={history} />;
}
